<template>
    <div>
        <span class="my-search-token"
            v-for="token in tokens">
				<button type="button" class="close" @click="closeToken(token)">&times;</button>
				{{token.label}}<span v-show="token.label && token.value">:</span> {{token.value}}

        </span>

    </div>
</template>

<script>
    import V from 'voUtils/V.js';
    import DateEx from 'voUtils/DateEx.js';

    export default {
    	voVueComponent: 'search-filter-tokens',
    	props: {
    		searchData: Object,
    		searchFields: Object
    	},
    	data: function() {
    		return {
    			tokens: []
    		};
    	},
    	methods: {
    		closeToken: function(token) {
    			for (let i = 0; i < this.tokens.length; i++) {
    				if (this.tokens[i] === token) {
    					let k = this.tokens[i].id;
    					this.searchData[k] = undefined;
    					V.log("deleting token", k);

    					if (k === 'from') {
    						this.searchData.till = undefined;
    					} else if (k === 'till') {
    						this.searchData.from = undefined;
    					} else if (k === 'pets') {
    						this.searchData.petsCount = undefined;
    					}
    					this.tokens.splice(i);

    					this.$nextTick(function() {
    						this.$emit('updated');
    					});
    					break;

    				}
    			}

    		},
    		update: function(nv) {
    			nv = nv || this.searchData;

    			this.tokens = [];

    			var field, value, v;

    			for (let k in nv) {
    				v = nv[k];

    				console.log('Filter::', v);

    				field = this.searchFields[k];

    				if (field && v && v !== '0' && v !== 'false' && k !== 'region') { //!_.isBlank(v)

    					value = null;

    					if (DateEx.isDate(v)) {

    						value = V.formatSimpleDate(v);

    					} else if (v !== true && v !== 'true' && k !== 'ids') {
    						//show value
    						if (field.options) {
    							value = field.options[v + ''];
    						} else {
    							value = v;
    						}
    					}

    					this.tokens.push({
    						id: k,
    						label: field.label,
    						value: value
    					});

    				}

    			}

    		}
    	}
    };
</script>

<style scoped>
    .my-search-token {
    	margin: 2px;
    	padding: 2px 6px;
    	display: inline-block;
    	border: 1px solid #ccc;
    	border-radius: 14px;

    	.close {
    		padding-left: 2px;
    		padding-right: 2px;
    	}
    }
</style>